import { useState } from "react";
import { useAxios } from "../../../utils/useAxios";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";

/**
 * @typedef {Object} StudentDataType
 * @property {number} id - Id of student
 * @property {boolean} is_assign - It represents whether we have to remove that student or add the
 * student
 */

/**
 * Custom hook to handle assigning students to a classroom
 */
export const useAssignStudents = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const { axiosInstance } = useAxios();

  /**
   * Assigns students to a classroom
   * @param {object} param
   * @param {number} param.classroomId - The classroom ID
   * @param {StudentDataType[]} param.studentsData - Students data to assign
   */
  const assignStudents = async ({ classroomId, studentsData }) => {
    setLoading(true);
    setError(null);
    setData(null);

    try {
      const response = await axiosInstance.post(
        `${TENANT_DOMAIN}/classroom/${classroomId}/assign-students`,
        {
          students: studentsData,
        },
      );

      setData(response.data);
      return response.data;
    } catch (err) {
      let firstErrorMessage = "";
      if (err?.response?.data?.errors) {
        firstErrorMessage = Object.values(err?.response?.data?.errors)[0][0];
      }

      if (err.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(
          firstErrorMessage ||
            err.response?.data?.message ||
            ERROR_MESSAGES.UNKNOWN,
        );
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    assignStudents,
    loading,
    error,
    data,
    setError,
  };
};
